module.exports = __webpack_public_path__ + "c7b9cb4be5f125b4a2daaad5d2253cfd.pdf";